import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useBilingual } from "@/lib/useBilingual";

/** Torna indietro: presente in alto a destra in ogni pagina. */
export const BackButton = ({ className = "", testId = "back-btn" }) => {
  const navigate = useNavigate();
  const { bt } = useBilingual();
  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/");
  };

  return (
    <button
      type="button"
      onClick={goBack}
      aria-label={bt("back")}
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 h-10 px-3 rounded-xl bg-gray-100 text-gray-600 text-xs font-bold hover:bg-gray-200 hover:text-gray-900 transition-colors ${className}`}
    >
      <ArrowLeft className="w-4 h-4" />
      <span className="hidden sm:inline">{bt("back")}</span>
    </button>
  );
};
